import React, { memo, useEffect, useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  > p {
    margin-bottom: 16px;
    font-size: 14px;
    color: #161d1f;
  }
`;

interface IProps {
  acceptedFiles: string[];
  maxFiles: number;
  maxSizeMegabytes: number;
  customText?: boolean;
}

const MemoDescription = memo<IProps>(
  ({ acceptedFiles, maxFiles, maxSizeMegabytes, customText = false }) => {
    const [names, setNames] = useState<string>('');

    useEffect(() => {
      const options = acceptedFiles.map((fileName, index) => {
        const name = fileName.toUpperCase();
        if (acceptedFiles.length === 1) return `${name}`;
        if (acceptedFiles.length === index + 1) return `o ${name}`;
        if (acceptedFiles.length - 1 === index + 1) return `${name} `;
        return `${name}, `;
      });
      setNames(options.join(''));
    }, [acceptedFiles]);

    return (
      <Wrapper>
        {customText ? (
          <p>
            Puedes subir máximo {String(maxFiles)} archivos en formato {names}.
            (carga máxima: {String(maxSizeMegabytes)} MB)
          </p>
        ) : (
          <p>
            Sólo puedes subir {String(maxFiles)} archivos en formato {names}.{' '}
            <b>(Carga máxima: {String(maxSizeMegabytes)} MB)</b>
          </p>
        )}
      </Wrapper>
    );
  },
  (prev, next) => prev.acceptedFiles === next.acceptedFiles
);

export default MemoDescription;
